<template>
    <v-form fast-fail @submit.prevent="handleSubmit">
        <h2 class="my-text-black" style="text-align: center;">Seleccione Obra social que va a auditar</h2>
        <v-autocomplete
            variant="solo"
            v-model="os"
            :items="opcionesOS"
            item-title="nombre"
            label="Obra Social"
            return-object
        >
        </v-autocomplete>
        <v-btn type="submit" block id="boton-verde">Seleccionar</v-btn>
    </v-form>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
</template>

<style src="../assets/base.css"></style>

<script>
    import { obligatorio } from '@/_helpers/rules';
    import AuthService from '@/api/AuthService';
    import AlertComponent from './AlertComponent.vue';

    const authService = new AuthService();

    export default {
        components:{
            AlertComponent
        },
        data() {
            return {
                os: null,
                opcionesOS: [],
                obligatorio: obligatorio,
                cargandoOS: false,
                //datos alert
                alertTitle: '',
                alertText: '',
                alertType: '',
                showAlert: false
            }
        },
        async mounted(){
            await this.cargarOSAuditor();
        },
        methods: {
            async handleSubmit(){
                if(this.os){
                    this.$store.commit('setObraSocial', this.os);
                    this.$router.push('/auditoria/listado-solicitudes-auditor');
                }
            },
            async cargarOSAuditor(){
                this.cargandoOS = true;
                const responseUsuario = await authService.buscarUsuario(this.$store.getters.getUsername);
                if(responseUsuario && responseUsuario.status === 200){
                    const response = await authService.getOSAuditor(responseUsuario.data.id);
                    if(response && response.status === 200){
                        this.opcionesOS = response.data;
                    } else {
                        this.alertTitle = 'Error';
                        this.alertText = 'No se pudieron cargar las obras sociales';
                        this.alertType = 'error';
                        this.showAlert = true;
                    } 
                } else {
                    this.alertTitle = 'Error';
                    this.alertText = 'No se encontró el usuario';
                    this.alertType = 'error';
                    this.showAlert = true;
                }
                this.cargandoOS = false;
            }
        }
    }
</script>